import { render, staticRenderFns } from "./StartStoreHeader.vue?vue&type=template&id=21a78f1e&scoped=true&"
import script from "./StartStoreHeader.vue?vue&type=script&lang=js&"
export * from "./StartStoreHeader.vue?vue&type=script&lang=js&"
import style0 from "./StartStoreHeader.vue?vue&type=style&index=0&id=21a78f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a78f1e",
  null
  
)

export default component.exports